module.exports = __webpack_public_path__ + "2618122f4e29098c147fbc075f1e828c.svg";